import { render, staticRenderFns } from "./DocumentFolder.vue?vue&type=template&id=1d0b3236&"
import script from "./DocumentFolder.vue?vue&type=script&lang=js&"
export * from "./DocumentFolder.vue?vue&type=script&lang=js&"
import style0 from "./DocumentFolder.vue?vue&type=style&index=0&id=1d0b3236&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports